// extracted by mini-css-extract-plugin
export default {"big":"IconButton-size_big__yySym","medium":"IconButton-size_medium__TfcfP","small":"IconButton-size_small__6La9Q"};